import React from 'react'
import { Icon, Popup } from "semantic-ui-react";
import { useTextResources } from "../language";

export const useFormFieldLabel = () => {
    var text = useTextResources()
    return (label, info)=>{
        if (info){
            return {children: <span>
                {label.includes(" ")? label:  text(label)}
                <Popup content={info.includes(" ")? info: text(info)} trigger={<Icon style={{margin: 3}} name='info circle'/>}/>
            </span>
            }
        } else {
            return text(label)
        }
        
    }
}

